import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-project-view-list',
  templateUrl: './project-view-list.component.html',
  styleUrls: ['./project-view-list.component.css']
})
export class ProjectViewListComponent implements OnInit {
  public idProject: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.idProject = this.route.snapshot.paramMap.get('idProject');
  }

}
